import { defineComponent, onMounted } from 'vue';
import RightsUsers from '@/presentation/components/rights/rights-users.vue';
import RightsCode from '@/presentation/pages/rights/rights.code';

export default defineComponent({
	components: {
		RightsUsers
	},
	setup: () => {
		const code = new RightsCode();

		onMounted(code.mounted.bind(code));

		return {};
	}
});
